import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  description: {
    wordBreak: 'break-word',
    display: '-webkit-box',
    margin: 0,
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  status: {
    color: '#929A92',
    fontWeight: 600,
    '&:first-letter': {
      textTransform: 'uppercase',
    },
  },
}));
